declare namespace $ {

	type $mol_number__value_rise_range_demo_1 = $mol_type_enforce<
		ReturnType< $rise_range_demo['value'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__value_min_rise_range_demo_2 = $mol_type_enforce<
		ReturnType< $rise_range_demo['min'] >
		,
		ReturnType< $mol_number['value_min'] >
	>
	type $mol_number__value_max_rise_range_demo_3 = $mol_type_enforce<
		ReturnType< $rise_range_demo['max'] >
		,
		ReturnType< $mol_number['value_max'] >
	>
	type $rise_range__value_rise_range_demo_4 = $mol_type_enforce<
		ReturnType< $rise_range_demo['value'] >
		,
		ReturnType< $rise_range['value'] >
	>
	type $rise_range__min_rise_range_demo_5 = $mol_type_enforce<
		ReturnType< $rise_range_demo['min'] >
		,
		ReturnType< $rise_range['min'] >
	>
	type $rise_range__max_rise_range_demo_6 = $mol_type_enforce<
		ReturnType< $rise_range_demo['max'] >
		,
		ReturnType< $rise_range['max'] >
	>
	type $rise_range__value_rise_range_demo_7 = $mol_type_enforce<
		ReturnType< $rise_range_demo['value'] >
		,
		ReturnType< $rise_range['value'] >
	>
	type $rise_range__disabled_rise_range_demo_8 = $mol_type_enforce<
		boolean
		,
		ReturnType< $rise_range['disabled'] >
	>
	type $rise_range__min_rise_range_demo_9 = $mol_type_enforce<
		ReturnType< $rise_range_demo['min'] >
		,
		ReturnType< $rise_range['min'] >
	>
	type $rise_range__max_rise_range_demo_10 = $mol_type_enforce<
		ReturnType< $rise_range_demo['max'] >
		,
		ReturnType< $rise_range['max'] >
	>
	type $mol_list__sub_rise_range_demo_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $rise_range_demo extends $mol_example_small {
		Number( ): $mol_number
		value( next?: number ): number
		min( ): number
		max( ): number
		Range( ): $rise_range
		Range_disabled( ): $rise_range
		List( ): $mol_list
		sub( ): readonly(any)[]
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map